module.exports = __webpack_public_path__ + "img/FooterCpptAni.77044175.png";